import { render, staticRenderFns } from "./1.vue?vue&type=template&id=022ade76&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"
import style0 from "./1.vue?vue&type=style&index=0&id=022ade76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ade76",
  null
  
)

export default component.exports